<div [ngClass]="[size(), type()]" class="button-close">
  @if (['small', 'smaller'].includes(size())) {
  <ui-inline-svg class="icon" [name]="'close-btn-small'"></ui-inline-svg>
  } @else {
  <ui-inline-svg class="icon" [name]="'close-btn'"></ui-inline-svg>
  }
</div>
